import React, { Fragment } from "react";
import ReactDOM from "react-dom";

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.modalRoot = document.getElementById("modal-root");

    // Create modal-root if it doesn't exist
    if (!this.modalRoot) {
      this.modalRoot = document.createElement("div");
      this.modalRoot.setAttribute("id", "modal-root");
      document.body.appendChild(this.modalRoot);
    }
  }

  componentDidMount() {
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if (this.modalRoot && this.el && this.modalRoot.contains(this.el)) {
      this.modalRoot.removeChild(this.el);
    }
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}

export default Modal;
